import { render, staticRenderFns } from "./CustomerManagementDetail.vue?vue&type=template&id=57c7768d&scoped=true"
import script from "./CustomerManagementDetail.vue?vue&type=script&lang=js"
export * from "./CustomerManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagementDetail.vue?vue&type=style&index=0&id=57c7768d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7768d",
  null
  
)

export default component.exports